import { Routes, Route } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import Home from "../pages/Home";
import Login from "../pages/Login";
import RequireAuth from "../components/requiredAuth";
import UniversalBenchmark from "../pages/UniversalBenchmark";
import RateCardConverter from "../pages/RateCardConverter";
import DataCleaning from "../pages/DataCleaning";
import UniversalBenchmarkCalculator from "../pages/UniversalBenchmarkCalculator";
import TicketPerformance from "../pages/TicketPerformance";
import MachshipTemplate from "../pages/MachshipTemplate";
import KPIPerformance from "../pages/KPIPerformance";
import MachshipTemplateAutomatic from "../pages/MachshipTemplateAutomatic";
import CustomerRateGenerator from "../pages/CustomerRateGenerator";
import PricingPowerpoint from "../pages/PricingPowerpoint";
import CustomerCareKPIPerformance from "../pages/CustomerCareKPIPerformance";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/auth" element={<RequireAuth isAuthPage={true} />}>
        <Route path="login" element={<Login />} />
      </Route>
      <Route element={<RequireAuth />}>
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<Home />} />
          <Route path="rateCardConverter" element={<RateCardConverter />} />
          <Route path="universalBenchmark" element={<UniversalBenchmark />} />
          <Route path="dataCleaning" element={<DataCleaning />} />
          <Route
            path="universalBenchmarkCalculator"
            element={<UniversalBenchmarkCalculator />}
          />
          <Route path="ticketPerformance" element={<TicketPerformance />} />
          <Route path="machshipTemplate" element={<MachshipTemplate />} />
          <Route
            path="machshipTemplateAutomatic"
            element={<MachshipTemplateAutomatic />}
          />
          <Route path="kPIPerformance" element={<KPIPerformance />} />
          <Route
            path="customerRatecardGenerator"
            element={<CustomerRateGenerator />}
          />
          <Route path="pricingPowerpoint" element={<PricingPowerpoint />} />
          <Route
            path="customerCareKPIPerformance"
            element={<CustomerCareKPIPerformance />}
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
